<style lang="scss" scoped>
.lottery-wrapper{
  margin-top: 189px;
  &-content{
    width:906px;
    height:447px;
    background:rgba(26,88,181,1);
    border-radius:26px;
    margin: 0 auto;
    padding: 46px 54px 56px 50px;
    display: flex;
    overflow: hidden;
    margin-top: 36px;
    &-list{
      background: url('./../assets/img/group28.svg') no-repeat;
      background-size: contain;
      width: 381px;
      height: 319px;
      margin-left: 50px;
      margin-top: 10px;
      &-title{
        margin-top: 16px;
        font-size:16px;
        font-family:PingFangSC-Semibold;
        font-weight:600;
        color:rgba(255,255,255,1);
        line-height:22px;
      }
      &-content{
      width: 327px;
      height: 236px;
      margin: 0 auto;
      margin-top: 25px;
      overflow: hidden;
      ul{
        padding: 20px;
        padding-right: 0;
        padding-top: 15px;
        li{
          height: 32px;
          display: flex;
          align-items: center;
          // margin-bottom: 10px;
          padding-bottom: 10px;
          span{
            font-size:13px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(59,50,27,1);
            line-height:18px;
          }
          .userimg{
            width: 28px;
            height: 28px;
            border-radius: 14px;
          }
          .username{
            margin-left: 9px;
            width: 80px;
            text-align: right;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .nbsp{
            margin-right: 8px;
          }
          .description{
            // width: 120px;
            text-align: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 50px;
          }
          .prize{
            width: 100px;
            margin-left: 15px;
            span{
              display: block;
              width: 100%;
              text-align: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
      &-share{
        margin-top: 20px;
        ul{
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 327px;
          margin: 0 auto;
          li{
            cursor: pointer;
            outline: none;
            border: none;
            margin: 0;
            padding: 0;
            width: 150px;
            height: 52px;
            background: url('./../assets/img/anniuxiao.svg') no-repeat;
            background-size: cover;
            font-size:15px;
            font-family:PingFangSC-Semibold;
            font-weight:600;
            color:rgba(194,52,18,1);
            line-height:52px;
            &:active{
              opacity: 0.9;
            }
          }
        }
      }
      &-tips{
        margin-top: 18px;
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:22px;
      }
    }
  }
}
</style>

<template>
<div class="lottery-wrapper" id="lottery">
  <div class="wrapper-reset">
    <Title :title="dayDrawLotteryData.title"></Title>
    <div class="lottery-wrapper-content">
      <div class="lottery-wrapper-content-turntable">
        <lotteryTurntable></lotteryTurntable>
      </div>

      <div class="lottery-wrapper-content-list">
        <p class="lottery-wrapper-content-list-title">中奖名单</p>
        <div class="lottery-wrapper-content-list-content">
          <ul v-if="userList" class="lottery-user-list ignore">
            <li v-for="item in userList">
              <img class="userimg" :src="item.usericon" alt="">
              <span class="username">{{item.username}}</span>
              <span class="nbsp">:</span>
              <span class="description">抽中了</span>
              <p class="prize"><span>{{item.prize}}</span></p>
            </li>
          </ul>
        </div>
        <div class="lottery-wrapper-content-list-share">
          <ul>
            <li @click="shareWb">立即分享</li>
            <li @click="showLotteryList">我的奖品</li>
          </ul>
        </div>
        <p class="lottery-wrapper-content-list-tips">
          {{dayDrawLotteryData.desc}}
        </p>
      </div>

      
    </div>
  </div>
</div>
</template>

<script>
import shareWeibo from './../assets/js/share-weibo';
import mShare from './../assets/js/mshare';
import Title from '@/components/Title';
import lotteryTurntable from './../components/lotteryTurntable';

export default {
  data() {
    return {
      userList: [],
      dayDrawLotteryData: {}
    }
  },
  components: {
    Title,
    lotteryTurntable
  },
  methods: {
    showLotteryList() {
      // this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_luckydraw_gift_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}});
      if(localStorage.getItem('isLogin') === 'true'){
        this.$bus.emit('showlotteryList');
      } else {
        this.$bus.emit('showLoginBox');
        this.$bus.emit('resetluckyTimes');
      }
    },
    // nodeBox---需要滚动的节点的父盒子(必须为ul)  spend---这个其实是单个子元素（必须为li）向上滚动的时间， 时间越短， 视觉速度越快
    listScroll(nodeBox, speed) {
      let $parent = this.$(nodeBox);
      let $first = $parent.find('li:first');
      let height = $first.height();
      let paddingBottom = parseInt( $first.css('paddingBottom') );
      $first.animate({
        marginTop: -height-paddingBottom + 'px',
       }, speed, 'linear', () => {
        $first.css('marginTop', 0).appendTo($parent);
        this.listScroll(nodeBox, speed);
      });
    },
    shareWb(){
      this.$http.addShareCount({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_luckydraw_shareweibo_click_all'},{headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}}).then((res) => {
       if(res.code === 10005){
          if(localStorage.getItem('isLogin') === 'true'){
            this.$toast({
              message: '登录已失效，请重新登录!',
              duration: 1500,
            });
          }
          localStorage.clear();
          this.$bus.emit('resetluckyTimes');
          this.$bus.emit('resetLogin');
          this.$bus.emit('showLoginBox');
          return false;
        }
       if(res.code !== 0 && res.code !== 10005){
        shareWeibo();
        this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_luckydraw_shareweibo_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}});
       }
       if(res.code === 0 && res.data.addPrizeChance === 1){
          shareWeibo();
          this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_luckydraw_shareweibo_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}});
          setTimeout(() => {
            this.$bus.emit('addPrizeChance');
          },3000);
        }
        /* if(res.code === 0 && res.data.addPrizeChance === 1){
          shareWeibo();
          setTimeout(() => {
            this.$bus.emit('addPrizeChance');
          },3000);
        }  else if(res.code === 10005) {
          this.$bus.emit('showLoginBox');
        } else {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.$toast({
              message: res.info,
              duration: 2000,
            })
          },500)
        } */
      })
    },
  },
  mounted() {
    this.$bus.on('share', () => {
      this.shareWb();
    })
    this.$http.loopPrize({actCode: this.$str('actCode'), count: this.$str('loopPrizeCount')}).then((res) => {
      this.userList = res.data;
    }).then(() => {
      if(this.userList.length > 5){
        this.listScroll('.lottery-user-list', 1000);
      }
    });
    this.$bus.on('dayDrawLotteryData', (data) => {
      this.dayDrawLotteryData = data;
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/blocks/Lottery.vue